<template>
    <div id="scriv-pro-wrapper">
      <section class="banner py-5">
        <div class="container py-3">
          <div class="d-flex flex-column flex-lg-row align-items-center">
            <div class="col-12 col-lg-6 text-center text-lg-left">
              <img src="/images/layout/logo.png" class="mb-3" width="80"/>
              <h1 class="fw-800 mb-3 font-size-large font-size-md-xLarge">Conheça nossos <br><span class="highlighted highlight-left">Planos e Preços</span></h1>
              <p class="font-size-xSmall" style="color:#4E5B72">Tenha acesso a e-books pagos e muitas outras <br class="d-none d-sm-block"/>funcionalidades exclusivas</p>
              <a href="#" class="btn btn-outline-color9 font-size-small fw-600" @click.prevent="slide">
                Saiba mais
              </a>
            </div>
            <div class="col-12 col-lg-6 column-image">
              <img src="/images/landing-pages/scriv-pro/img-header.png" alt="">
            </div>
          </div>
        </div>
      </section>
      <section id="description" class="desc background-color9 py-5">
        <div class="container py-4">
          <h2 class="text-white text-center fw-800 mb-4">Para leitores ou escritores, conheça a Scriv Pro</h2>
          <p class="text-white text-center text-md-left">Criamos uma modalidade paga da Scriv para oferecer serviços adicionais aos nossos usuários mais assíduos. Na versão Pro, você terá acesso a estatísticas avançadas e integração com o Kindle, além de poder, mensalmente, doar um café e adquirir um livro pago.</p>
        </div>
      </section>
      <section class="pricing">
        <div class="container">
          <div id="pricing-table" class="d-flex flex-column flex-md-row flex-wrap justify-content-center align-items-center">
            <template v-if="loader">
              <Loader
                color="white"
                size="big"
              />
            </template>
            <template v-else-if="product">
              <div class="col-12 col-sm-10 col-md-6 col-lg-4 mb-5">
                <div class="card">
                  <div class="card-body">
                    <small class="fw-500 font-size-small">Cadastro Padrão</small>
                    <h3 class="fw-600 pt-3">Grátis</h3>
                    <ul>
                      <li>Acesso a Conteúdos Gratuitos  <img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                      <li>Publicações destacadas na Home <img src="/images/landing-pages/scriv-pro/icon-times-circle.png"></li>
                      <li>Integração com Kindle e e-Readers <img src="/images/landing-pages/scriv-pro/icon-times-circle.png"></li>
                      <li>Estatísticas Avançadas <img src="/images/landing-pages/scriv-pro/icon-times-circle.png"></li>
                      <li>Doação de um Café/mês<img src="/images/landing-pages/scriv-pro/icon-times-circle.png"></li>
                      <li>Acesso a um Livro Pago/mês<img src="/images/landing-pages/scriv-pro/icon-times-circle.png"></li>
                      <li>Funcionalidades Extras<img src="/images/landing-pages/scriv-pro/icon-times-circle.png"></li>
                      <li>Acesso a todas as Comunidades<img src="/images/landing-pages/scriv-pro/icon-times-circle.png"></li>
                      <li>Acesso a todos os Livros Pagos<img src="/images/landing-pages/scriv-pro/icon-times-circle.png"></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-10 col-md-6 col-lg-4 mb-5">
                <div class="card">
                  <div class="card-body">
                    <small class="fw-500 font-size-small">Pro</small>
                    <h3 class="fw-600 pt-3">{{ product.amount/100 | formatMoney }}<small class="text-gray font-size-xSmall">/mês</small></h3>
                    <ul>
                      <li>Acesso a Conteúdos Gratuitos  <img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                      <li>Publicações destacadas na Home <img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                      <li>Integração com Kindle e e-Readers <img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                      <li>Estatísticas Avançadas <img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                      <li>Doação de um Café/mês<img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                      <li>Acesso a um Livro Pago/mês<img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                      <li>Funcionalidades Extras<img src="/images/landing-pages/scriv-pro/icon-times-circle.png"></li>
                      <li>Acesso a todas as Comunidades<img src="/images/landing-pages/scriv-pro/icon-times-circle.png"></li>
                      <li>Acesso a todos os Livros Pagos<img src="/images/landing-pages/scriv-pro/icon-times-circle.png"></li>
                    </ul>
                    <Button
                      class="btn btn-color9 btn-block font-size-xSmall fw-600"
                      :disabled="true"
                      v-if="user && user.is_scriv_pro_enabled"
                    >
                      Você já é assinante
                    </Button>
                    <Button
                      class="btn btn-color9 btn-block font-size-xSmall fw-600"
                      @click="openCheckoutModal"
                      v-else
                    >
                      Assinar
                    </Button>
                    <p class="text-center font-size-xSmall mt-3">O cancelamento pode ser feito a qualquer momento, sem cobrança de multa.</p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-10 col-md-6 col-lg-4 mb-5">
                <div class="card">
                  <div class="card-body">
                    <small class="fw-500 font-size-small">Premium</small>
                    <h3 class="fw-600 pt-3">R$ 24,90<small class="text-gray font-size-xSmall">/mês</small></h3>
                    <ul>
                      <li>Acesso a Conteúdos Gratuitos  <img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                      <li>Publicações destacadas na Home <img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                      <li>Integração com Kindle e e-Readers <img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                      <li>Estatísticas Avançadas <img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                      <li>Doação de um Café/mês<img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                      <li>Funcionalidades Extras<img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                      <li>Acesso a todas as Comunidades<img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                      <li>Acesso a todos os Livros Pagos<img src="/images/landing-pages/scriv-pro/icon-check-circle.png"></li>
                    </ul>
                    <Button
                      class="btn btn-color9 btn-block font-size-xSmall fw-600 disabled"
                    >
                      Em breve
                    </Button>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div id="faq" class="d-flex flex-column flex-md-row justify-content-center py-5 mx-auto ">
              <div class="px-0 py-md-5 py-3 col-md-5 col-xl-4 mx-md-4 text-center text-lg-left">
                <img src="/images/landing-pages/scriv-pro/faq.png" width="70" class="mb-2"/>
                <h2 class="title fw-800 mt-1 mb-md-4 text-color2">PERGUNTAS <br class="d-md-block" />FREQUENTES</h2>
                <p class="text-color1 ">Restou alguma dúvida? Envie um email <br class="d-md-block" />para <a href="mailto:contato@scriv.com.br" class="text-color1 font-weight-bold text-decoration-underline">contato@scriv.com.br</a></p>
              </div>
              <div class="px-0 py-md-5 py-0 col-md-6 mx-md-4">
                <div class="accordion" role="tablist">
                  <div no-body class="py-2 px-4 accordion-item m-3">
                    <div class="accordion-header" v-b-toggle="`accordion-2-1`">
                      <h4 class="font-weight-bold text-color2">Como faço para assinar a Scriv Pro?</h4>
                    </div>
                    <b-collapse :id="`accordion-2-1`" accordion="my-accordion" role="tabpanel">
                      <div>
                        <div><p style="color: #1d1d1d">Basta <a href="#" @click.prevent="openCheckoutModal" class="link-color1">clicar aqui</a> ou no botão "Assinar" da tabela acima. Caso já tenha seu cartão de crédito cadastrado na Scriv, a compra é finalizada após sua confirmação. Caso ainda não tenha, basta cadastrar seus dados e seguir para a finalização.</p></div>
                      </div>
                    </b-collapse>
                  </div>
                  <div no-body class="py-2 px-4 accordion-item m-3">
                    <div class="accordion-header" v-b-toggle="`accordion-2-2`">
                      <h4 class="font-weight-bold text-color2">Existe multa de cancelamento?</h4>
                    </div>
                    <b-collapse :id="`accordion-2-2`" accordion="my-accordion" role="tabpanel">
                      <div>
                        <div><p style="color: #1d1d1d">Não existe multa para o cancelamento do plano. Ao solicitar a descontinuidade da sua assinatura, as futuras cobranças são canceladas.</p></div>
                      </div>
                    </b-collapse>
                  </div>
                  <div no-body class="py-2 px-4 accordion-item m-3">
                    <div class="accordion-header" v-b-toggle="`accordion-2-3`">
                      <h4 class="font-weight-bold text-color2">Posso compartilhar minha assinatura?</h4>
                    </div>
                    <b-collapse :id="`accordion-2-3`" accordion="my-accordion" role="tabpanel">
                      <div>
                        <div><p style="color: #1d1d1d">A assinatura da Scriv é individual, para cada perfil da plataforma, não sendo possível o compartilhamento da mesma.</p></div>
                      </div>
                    </b-collapse>
                  </div>
                  <div no-body class="py-2 px-4 accordion-item m-3">
                    <div class="accordion-header" v-b-toggle="`accordion-2-4`">
                      <h4 class="font-weight-bold text-color2">Quando a modalidade Premium ficará disponível?</h4>
                    </div>
                    <b-collapse :id="`accordion-2-4`" accordion="my-accordion" role="tabpanel">
                      <div>
                        <div><p style="color: #1d1d1d">Estamos trabalhando nisso! Compartilharemos essa e muitas outras novidades da Scriv aqui no site e em nossas redes sociais.</p></div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </section>

      <TheCheckoutModal
        :products="[{
          id: product.id,
          type: 'product'
        }]"
        :paymentMethods="product.available_payment_methods"
        @purchase-completed="purchaseCompleted"
        v-if="product"
      />
    </div>
</template>

<script>

import ProductsService from '@/modules/products/services/products-service'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'
import TheCheckoutModal from '@/components/checkout/TheCheckoutModal'

export default {
  metaInfo: {
    title: 'Scriv Pro',
    meta: [
      { vmid: 'description', name: 'description', content: '' },
      { vmid: 'og-description', name: 'og:description', content: '' }
    ]
  },
  components: {
    Button,
    Loader,
    TheCheckoutModal
  },
  data () {
    return {
      faq: [],
      loader: true,
      product: ''
    }
  },
  created () {
    this.getProducts()
  },
  computed: {
    ...mapState('auth', {
      authenticated: state => state.authenticated
    }),
    ...mapState('users', {
      user: state => state.user
    })
  },
  methods: {
    /**
     * Get products
     */
    async getProducts () {
      this.loader = true
      try {
        const products = await ProductsService.getProducts({
          type: 'scriv_pro'
        })
        if (products.length > 0) this.product = products[0]
      } catch (error) {
        console.log(error)
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    openCheckoutModal () {
      if (!this.authenticated) {
        this.$bvModal.show('auth-modal')
        return
      }
      if (this.user && this.user.is_scriv_pro_enabled) return
      this.$bvModal.show('checkout-modal')
    },
    slide () {
      const elem = document.getElementById('description').getBoundingClientRect()
      window.scrollTo({ top: (elem.top - 50), behavior: 'smooth' })
    },
    purchaseCompleted () {}
  }
}

</script>

<style lang="scss" scoped>
  #scriv-pro-wrapper {
    margin: -50px 0;
    font-family: $font2;
    background-color: $color8;
    overflow-x: hidden;
    .text-gray {
      color: rgba(0, 0, 0, 0.45);
    }
    .fw-500 {
        font-weight: 500!important;
    }
    .fw-600 {
        font-weight: 600!important;
    }
    .fw-800 {
        font-weight: 800!important;
    }

    p {
      font-size: 16px;
    }

    .background-color9 {
      background-color: $color9;
    }

    .banner {
      img {
        position: relative;
        z-index: 1;
      }

      .column-image {
        &::after {
          content: '';
          position: absolute;
          top: 0;
          right: calc(50% - 107px);
          width: 214px;
          height: 710px;
          background: url('/images/landing-pages/scriv-pro/elipse.png');
          background-size: 100% auto;
          background-repeat: no-repeat;

          @include tablet {
            right: calc(50% - 207px);
            width: 414px;
          }

          @include desktop {
            top: -220px;
            right: calc(50% - 271px);
            width: 542px;
          }
        }
      }

      .highlighted {
        z-index: 1;

        &:before {
          background-color: #fff;
          width: 108%;
          right: -5%;
          opacity: 1;
        }
      }
    }

    .btn-color9 {
      background: $color9;
      font-weight: bold;
      border-color: $color9;
      color: #fff;

      &:hover, &:focus {
        background: #D5544C;
        border-color: #fff;
        color: #fff;
      }
    }

    .btn-outline-color9 {
      background: transparent;
      font-weight: bold;
      border-color: $color9;
      color: $color9;

      svg {
          width: 20px;
          display: inline-block;
          margin-right: 5px;
      }

      &:not(:disabled):not(.disabled).active, &:not(:disabled):not(.disabled):active, &:hover, &:focus {
        border: 2px solid $color9;
        color: #000;

        svg {
          path {
            fill: #000;
          }
        }
      }
    }

    .desc {
      height: 550px;

      @media (min-width: 576px) {
        height: 450px;
      }
    }

    .pricing{
      position: relative;
      z-index: 1;

      @include desktop{
        margin-top: -210px;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: -50px;
          width: 478px;
          height: 592px;
          background: url('/images/landing-pages/scriv-pro/bg-expo-left.png');
          background-size: 100% auto;
          background-repeat: no-repeat;
          z-index: -1;
          transform: scaleY(-1);
        }

        &::after {
          content: '';
          position: absolute;
          top: -80px;
          right: -50px;
          width: 542px;
          height: 710px;
          background: url('/images/landing-pages/scriv-pro/bg-expo-right.png');
          background-size: 100% auto;
          background-repeat: no-repeat;
          z-index: -1;
        }
      }

      #pricing-table {
        position: relative;
        margin-top: -80px;

        @include tablet {
          margin-top: -100px;
        }

        @include desktop{
          margin-top: -150px;
        }
        .card {
          border-radius: 20px;
          box-shadow: 0px 10px 50px rgba(0, 0, 0, 0.16);
          border: none;

          .card-body{
            padding: 35px 30px;
          }

          &:hover {
            box-shadow: none;
          }

          ul {
            font-size: 12px;

            li {
              padding: 8px 0;
              display: flex;
              letter-spacing: 0.42px;
              justify-content: space-between;
              align-items: center;

              img {
                width: 20px;
              }
            }
          }
        }
      }

      #faq{
        .accordion-item{
          border: 2px solid $color2;
          border-radius: 25px;
          .accordion-header{
            &.not-collapsed {
              h4::after {
                content: '-';
              }
            }

            h4{
              font-size: 19px;
              margin-bottom: 0;
              position: relative;
              padding-right: 20px;

              &::after {
                content: '+';
                position: absolute;
                right: 0;
                top: -2px;
                color: $color2;
                font-size: 20px;
                font-weight: bold;
              }
            }
          }
          .collapse.show {
            padding-top: 15px;
          }
        }
      }
    }
  }

</style>
